const RoundTo = (value) => {
    return Math.round(value);
}
 
export default RoundTo;